var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8285 1.44775H48.4815C53.6286 1.44775 57.8017 5.62089 57.8017 10.768V47.8625C57.8017 53.0096 53.6286 57.1827 48.4815 57.1827H10.8285C5.68143 57.1827 1.5083 53.0096 1.5083 47.8625V10.768C1.5083 5.62089 5.68143 1.44775 10.8285 1.44775Z",
    fill: "#575E3B",
    stroke: "#A79E83",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1434 24.4571H31.5311V21.1119C31.5311 19.0039 31.4201 17.6836 31.2003 17.1523C30.9789 16.6211 30.4554 16.3562 29.6282 16.3562C28.9114 16.3562 28.4236 16.5838 28.1665 17.0389C27.9094 17.4941 27.7805 18.6622 27.7805 20.5433V38.2238C27.7805 39.8774 27.9094 40.9647 28.1665 41.4882C28.4236 42.0117 28.9385 42.2742 29.7113 42.2742C30.5572 42.2742 31.1311 41.9783 31.4348 41.3865C31.7385 40.7946 31.8915 39.642 31.8915 37.9279V33.559H29.5459V27.9607H43.1441V47.7351H35.8464L34.7722 45.0959C33.9816 46.2338 32.9835 47.0858 31.7781 47.6551C30.5727 48.2236 29.1514 48.5095 27.5126 48.5095C25.5615 48.5095 23.7363 48.118 22.0346 47.3367C20.3321 46.5553 19.0397 45.5891 18.1543 44.4365C17.2712 43.2839 16.7197 42.0731 16.4991 40.8063C16.2786 39.5395 16.1683 37.6405 16.1683 35.107V24.1611C16.1683 20.642 16.3982 18.0859 16.858 16.4929C17.317 14.8999 18.6366 13.4405 20.8152 12.1124C22.9946 10.7851 25.8132 10.1218 29.271 10.1218C32.6713 10.1218 35.4946 10.6988 37.74 11.8514C39.9822 13.004 41.4447 14.3741 42.1243 15.9586C42.8055 17.5438 43.1449 19.8459 43.1449 22.8649V24.4571H43.1434Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.126,
    height: 58.601,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSidebar);
export default __webpack_public_path__ + "static/media/logo_sidebar.6ea6039c50386ff3d543e156f7067144.svg";
export { ForwardRef as ReactComponent };